import { createFileRoute } from '@tanstack/react-router'

import { OverviewScreen } from './-components/overview-screen.tsx'

export const Route = createFileRoute('/risk/chargebacks-overview')({
  component: OverviewScreen
})
